/* ─── A1CW Theme V17 · cfpq-watcher.js ──────────────────
   Server-side, price.liquid renders "Contact For Price Quote"
   whenever price === 0. When the customer selects a variant on
   the PDP, base-theme JS re-renders the price from variant.price
   and clobbers our CFPQ link with "$0.00".

   This script restores the CFPQ link whenever a .price element
   ends up displaying $0.00 (or 0.00). It also re-applies after
   the variant-id input changes.
   ──────────────────────────────────────────────────────── */

(function () {
  'use strict';

  var CFPQ_TEXT = 'Contact For Price Quote';
  var CFPQ_HREF = '/pages/contact-us';
  var ZERO_RE = /^\s*\$?0(?:[.,]00)?\s*$/;

  function isZeroPriceText(text) {
    if (!text) return false;
    var t = text.replace(/ /g, ' ').trim();
    if (ZERO_RE.test(t)) return true;
    // also catch "From $0.00"
    return /^\s*From\s+\$?0(?:[.,]00)?\s*$/i.test(t);
  }

  function alreadyCfpq(el) {
    return el && el.querySelector && el.querySelector('.price__cfpq');
  }

  function renderCfpq(priceEl) {
    if (!priceEl || alreadyCfpq(priceEl)) return;
    while (priceEl.firstChild) priceEl.removeChild(priceEl.firstChild);
    var a = document.createElement('a');
    a.className = 'price__cfpq';
    a.href = CFPQ_HREF;
    a.textContent = CFPQ_TEXT;
    priceEl.appendChild(a);
  }

  function checkAll(root) {
    var scope = root || document;
    var prices = scope.querySelectorAll ? scope.querySelectorAll('.price') : [];
    for (var i = 0; i < prices.length; i++) {
      var p = prices[i];
      if (alreadyCfpq(p)) continue;
      if (isZeroPriceText(p.textContent)) renderCfpq(p);
    }
  }

  // Initial pass after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { checkAll(); });
  } else {
    checkAll();
  }

  // Watch for downstream price re-renders (variant selection, section render API)
  var mo = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var r = records[i];
      if (r.type === 'characterData' || r.type === 'childList') {
        // Find the closest .price ancestor of the change site
        var target = r.target;
        var priceEl = target.nodeType === 1 ? target.closest && target.closest('.price') : (target.parentNode && target.parentNode.closest && target.parentNode.closest('.price'));
        if (priceEl) {
          if (!alreadyCfpq(priceEl) && isZeroPriceText(priceEl.textContent)) {
            renderCfpq(priceEl);
          }
        } else if (r.addedNodes && r.addedNodes.length) {
          // Section render replaced a chunk — sweep within added nodes
          for (var j = 0; j < r.addedNodes.length; j++) {
            var n = r.addedNodes[j];
            if (n.nodeType === 1) checkAll(n);
          }
        }
      }
    }
  });

  mo.observe(document.body || document.documentElement, {
    subtree: true,
    childList: true,
    characterData: true
  });
})();
